import { Component, OnInit, Output } from '@angular/core';
import { CourseMaster } from '../model/CourseMaster.model';
import { AuthService } from '../service/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router, NavigationEnd } from '@angular/router';
import { User } from '../model/User.model';
import { EnrollCourseMaster } from '../model/EnrollCourseMaster.model';
import { StudentMaster } from '../model/StudentMaster.model';
import { MainserviceService } from '../service/mainservice.service';
import Swal from 'sweetalert2'
import { PaymentIntegration } from '../model/PaymentIntegration.model';
import { PredefinedMaster } from '../model/PredefinedMaster.model';
import { CourseFeesMaster } from '../model/CourseFeesMaster.model';
import Player from '@vimeo/player';
import { CartMaster } from '../model/CartMaster.model';
import { TrainerMaster } from '../model/TrainerMaster.model';
import { TestimonialMaster } from '../model/TestimonialMaster.model';
import {MessageService} from 'primeng/api';
import { FaqMaster } from '../model/FaqMaster.model';
import { DocumentMaster } from '../model/DocumentMaster.model';
import { DomSanitizer } from '@angular/platform-browser';
import { Meta } from '@angular/platform-browser';  
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {

  studentdashbord: any;
  gallerycarousel: any;
  gallerycarousel1:any
  showDialog: boolean=false;
  showDialogTrainer:boolean=false;
  trainerMasterTemp:TrainerMaster=new TrainerMaster();
  courseMasterTemp:CourseMaster=new CourseMaster();

  totalRecords:number=0;
  showbtn:boolean=true;

  cartMaster:CartMaster=new CartMaster();


  tempCourse:CourseMaster[]=[];
  trainermasterFilter:TrainerMaster=new TrainerMaster();
  trainerMasterList:TrainerMaster[]=[];

  faqMaster:FaqMaster=new FaqMaster();
  faqMasterList:FaqMaster[]=[];
  faqTempList:any[]=[];
  

  student:StudentMaster=new StudentMaster();
  pageSize: number = 5;
  pageNumber: number = 0;
  testimonialFilter:TestimonialMaster=new TestimonialMaster();
  testimonialList:TestimonialMaster[]=[];
  showVideo:boolean=false;

  value: boolean=false;
  value1: boolean=false;
  count: any;
  testimonialcarousel: any;
  couseListTemp: CourseMaster = new CourseMaster();
  courseMaster: CourseMaster = new CourseMaster();
  courseMasterList:CourseMaster[]=[];
  cousrMasterData: CourseMaster = new CourseMaster();
  userSession: User = new User();
  @Output() enrollCourseMaster: EnrollCourseMaster = new EnrollCourseMaster();
  displaystudentenroll: boolean = false;
  displayloginconfirm: boolean = false;
  studentDob: Date = new Date();
  paymentIntegration: PaymentIntegration = new PaymentIntegration();
  studentMaster: StudentMaster = new StudentMaster();
  predefineMasterList: PredefinedMaster[] = [];
  courseFeature: CourseFeesMaster[] = [];
  totalAmount: number = 0;
  documentMasterTemp:DocumentMaster=new DocumentMaster();
  player;
  constructor(private authService: AuthService, private router: Router, private mainService: MainserviceService , private messageService: MessageService,
    private sanitizer: DomSanitizer,private meta: Meta,private titleService: Title) { 
      this.meta.updateTag({ name: 'description', content: "The Ultimate Online Real Estate Learning Platform in India, become the master in real estate with Edstate's career oriented courses; curated by the pro's for the future pro's." });
      titleService.setTitle("The Ultimate Real Estate Certification Programs for Industry Professionals & Aspiring Individuals | Edstate");
    }

  ngOnInit() {
    this.getCourseMasterById();
    this.student=this.authService.getUserSession();
    this.getCourseMasterList();
    this.getTrainerMasterList();
    this.getTestimonialList();
    this.getFaqList();

   
     
    
   

    // gallery carousel

    this.gallerycarousel = {
      loop: false,
      autoplay: false,
      margin: 20,
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      dots: true,
      items: 4,
      navSpeed: 1000,
      navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
      responsive: {
        0: {
          items: 1
        },
        400: {
          items: 2
        },
        740: {
          items: 3
        },
        940: {
          items: 4
        }
        
        
      },
      nav: true
    }

    this.gallerycarousel1 = {
      loop: false,
      autoplay: false,
      margin: 20,
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      dots: true,
      navSpeed: 1000,
      navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
      responsive: {
        0: {
          items: 1
        },
        400: {
          items: 2
        },
        740: {
          items: 2
        },
        940: {
          items: 3
        }
      },
      nav: true
    }


    this.testimonialcarousel = {
      loop: false,
      margin: 0,
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      dots: true,
      items: 2,
      navSpeed: 1000,
      navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
      responsive: {
        0: {
          items: 1
        },
        400: {
          items: 1
        },
        740: {
          items: 1
        },
        940: {
          items: 1
        }
      },
      nav: true
    }

    

 

  }
 tomasterPage(){
   this.router.navigateByUrl('/master-course');
 }

 viewDialog(){


  this.showDialog=true;
 
  
}

viewDialogTrainer(trainerMaster:TrainerMaster){
  this.trainerMasterTemp=new TrainerMaster()
  this.trainerMasterTemp=trainerMaster;
  this.showDialogTrainer=true;
  
}
 
navigateCourse(){
  this.router.navigateByUrl('/courses')
}


getCourseMasterById(){
   
  

 this.mainService.getMasterCourse(this.courseMasterTemp).subscribe(data => {
   this.courseMaster = data;


}, (err: HttpErrorResponse) => {
  if (err.status === 200) {
    let jsonString = err.error.text;
    jsonString = jsonString.substr(0, jsonString.indexOf('{"timestamp"'));
    // this.packageServiceList = JSON.parse(jsonString);

  }


})


}

pleaseLogin(){
  this.messageService.add({severity:'error', summary:'Please Login', detail:'to continue'});
}

buyCourse(){
  this.courseMaster.courseLectureMasterList = [];
  this.tempCourse.push(this.courseMaster);
  this.authService.setcourseListSession(this.tempCourse);

  

  this.router.navigateByUrl('/payment-confirmation');
}

closeBannerVideo(){
  this.showVideo=false;
}


getCourseMasterList() {
  this.couseListTemp.isMasterCourse=false;

  this.couseListTemp.pageNumber = this.couseListTemp.pageNumber
    ? this.couseListTemp.pageNumber
    : this.pageNumber;
  this.couseListTemp.pageSize = this.couseListTemp.pageSize
    ? this.couseListTemp.pageSize
    : this.pageSize;

  // this.couseListTemp.isMasterCourse=false;
  
  this.mainService.getCourseMasterList(this.couseListTemp).subscribe(
    (data) => {
      this.courseMasterList = data;
      this.getCourseMasterListLength();

      // this.tempcourseMasterList=[]
      // this.courseMasterList.forEach((element,index) => {
  
      //   this.tempcourseMasterList.push(element);
      
      
      // })
      
      
    },
    (error) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 200) {
          let jsonString = error.error.text;
          jsonString = jsonString.substr(
            0,
            jsonString.indexOf('{"timestamp"')
          );
          //   this.spinnerService.hide();
          return JSON.parse(jsonString);
        } else {
          this.authService.showMessage('error', 'Something went wrong', '');
          //  this.spinnerService.hide();
        }
      }
    }
  );
}


incrementPage(){

  this.couseListTemp.pageNumber=this.couseListTemp.pageNumber
  this.couseListTemp.pageSize=this.couseListTemp.pageSize+5;


  this.getCourseMasterList();
  
  
  if(this.couseListTemp.pageSize>=this.totalRecords){
   
    this.showbtn=false;
  }
}

getCourseMasterListLength() {
   





  this.mainService.getCourseMasterListLength(this.couseListTemp).subscribe(data => {
    this.totalRecords = data;
    

  }, (err: HttpErrorResponse) => {
    if (err.status === 200) {
      let jsonString = err.error.text;
      jsonString = jsonString.substr(0, jsonString.indexOf('{"timestamp"'));
      this.couseListTemp = JSON.parse(jsonString);

    }


  })
}



getTrainerMasterList() {

  this.mainService.getTrainerMasterList(this.trainermasterFilter).subscribe(
    (data) => {
      this.trainerMasterList = data;
      
    },
    (error) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 200) {
          let jsonString = error.error.text;
          jsonString = jsonString.substr(
            0,
            jsonString.indexOf('{"timestamp"')
          );
          //   this.spinnerService.hide();
          return JSON.parse(jsonString);
        } else {
          this.authService.showMessage('error', 'Something went wrong', '');
          //  this.spinnerService.hide();
        }
      }
    }
  );
}

getFaqList() {

  this.mainService.getFaqList(this.faqMaster).subscribe(
    (data) => {
      this.faqMasterList = data;
     
      
    },
    (error) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 200) {
          let jsonString = error.error.text;
          jsonString = jsonString.substr(
            0,
            jsonString.indexOf('{"timestamp"')
          );
          //   this.spinnerService.hide();
          return JSON.parse(jsonString);
        } else {
          this.authService.showMessage('error', 'Something went wrong', '');
          //  this.spinnerService.hide();
        }
      }
    }
  );
}


navigateTrainer(trainerMaster:TrainerMaster){
  this.authService.setTrainerSession(trainerMaster);
  this.router.navigateByUrl('/trainer-profile')
}





getTestimonialList() {
 
  this.mainService.getTestimonialList(this.testimonialFilter).subscribe(
    (data) => {
      this.testimonialList = data;
      // this.getTestimonialListLength();
    },
    (error) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 200) {
          let jsonString = error.error.text;
          jsonString = jsonString.substr(
            0,
            jsonString.indexOf('{"timestamp"')
          );
          //   this.spinnerService.hide();
          return JSON.parse(jsonString);
        } else {
          this.authService.showMessage('error', 'Something went wrong', '');
          //  this.spinnerService.hide();
        }
      }
    }
  );
}


viewCourse(courseMaster:CourseMaster){
  this.authService.setcourseMasterSession(courseMaster);
  
    this.router.navigateByUrl('/course-details');
  
}


videoDisplay(){

  this.documentMasterTemp = this.courseMaster.courseBannerVideo;
  if (this.documentMasterTemp.linkId != null && this.documentMasterTemp.linkId != undefined) {
    this.documentMasterTemp.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.documentMasterTemp.link);
  }


  this.showVideo=true;

  setTimeout(() => {
    this.initPlayer();
    this.setVideo(this.documentMasterTemp.linkId);
  
    this.playVideo();
   
  }, 500);

}


public initPlayer() {
  this.player = new Player('video_iframe', {});
  // this.updateVideoCompleted();
}

setVideo(videoId: any) {

  this.player.loadVideo(videoId).then(function (id) {

  });

}

playVideo() {
  setTimeout(() => {
    this.player.play().then(function () {

    });
  }, 1000);

}

 
}
